module.exports = __webpack_public_path__ + "static/media/MCII_duo.3a62b5b8.png";